import { DatastoreObjectType, DatastoreObjectTypes, HydrateableSkMappedItems, IEdgeMappedItems } from '@iotv/iotv-v3-types'
import path from 'path'
import { NodeEdgeMapper } from '../../model/constructs'
import { DEBUG_OVERRIDE, NOT_LAMBDA } from '../lambda'
import { outputToPath, readObjectFromPath } from './outptutFns'

const debug = DEBUG_OVERRIDE || (NOT_LAMBDA && false)

export type KnownKeysProps = {
  /** the fully resolved path including folder but not filename or extension*/
  absoluteFilePath: string
  fileName: string
}

/**
 * maintains an memory and locally persisted nodeEdgeMapper, hydrates on calling hydrate if file exists
 */
export class KnownKeys<NEMType extends DatastoreObjectType = DatastoreObjectType> {
  constructor({ absoluteFilePath, fileName }: KnownKeysProps) {
    this.nodeEdgeMapper = new NodeEdgeMapper<NEMType>()
    this.fileName = fileName
    this.absoluteFilePath = absoluteFilePath
  }

  isHydrated: boolean = false
  absoluteFilePath: string
  fileName: string
  nodeEdgeMapper: NodeEdgeMapper<NEMType>

  clear = () => {
    this.nodeEdgeMapper = new NodeEdgeMapper<NEMType>()
  }

  hydrate = async () => {
    const nodeMapperZombieRes = await readObjectFromPath(this.absoluteFilePath, this.fileName)
    if (nodeMapperZombieRes.data) {
      this.nodeEdgeMapper = new NodeEdgeMapper<NEMType>(nodeMapperZombieRes.data as HydrateableSkMappedItems<NEMType>)
      this.isHydrated = true
      debug && console.log(`Hydrated nodeEdgeMapper from ${path.join(this.absoluteFilePath, this.fileName)}`)
      debug && console.log(this.nodeEdgeMapper.containedTypes())
    } else {
      console.log(`Error hydrating known keys store`, nodeMapperZombieRes.err?.message)
      await this.persist()
    }
  }

  persist = async () => {
    debug && console.log(`persisting to ${this.absoluteFilePath}/${this.fileName}`)
    const persistRes = await outputToPath(this.absoluteFilePath, this.fileName, this.nodeEdgeMapper)
    if (persistRes.err) {
      throw new Error(`Err is persist,${persistRes.err.message}`)
    }
  }

  addItemToKnownKeys = (item: NEMType) => {
    this.nodeEdgeMapper.loadItem(item)
    if (!this.isHydrated) {
      debug && console.log(`KnownKeys is not hydrated`)
    }
  }

  addItemsToKnownKeys = (items: NEMType[]) => items.forEach((item) => this.addItemToKnownKeys(item))

  isKnownKey = (item: NEMType) => this.nodeEdgeMapper.itemExists(item)
}
